import React, { lazy, Suspense } from 'react';
import { Switch, Redirect } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import Route from './Route';

// const Home = lazy(() =>
//   import(
//     /* webpackPrefetch: true */ /* webpackChunkName: "lazyHome" */ '../Home'
//   ),
// );
// const Marketplace = lazy(() =>
//   import(
//     /* webpackPrefetch: true */ /* webpackChunkName: "lazyMarketplace" */ '../Marketplace'
//   ),
// );

const TempHome = lazy(() =>
  import(
    /* webpackPrefetch: true */ /* webpackChunkName: "lazyHome" */ '../TempHome'
  ),
);

const TempMarketplace = lazy(() =>
  import(
    /* webpackPrefetch: true */ /* webpackChunkName: "lazyMarketplace" */ '../TempMarketplace'
  ),
);

const Layout = lazy(() =>
  import(
    /* webpackPrefetch: true */ /* webpackChunkName: "lazyLayout" */ '../../pages/Layout'
  ),
);
const MainData = lazy(() =>
  import(
    /* webpackPrefetch: true */ /* webpackChunkName: "lazyMainData" */ '../../pages/MainData'
  ),
);
const Security = lazy(() =>
  import(
    /* webpackPrefetch: true */ /* webpackChunkName: "lazySecurity" */ '../../pages/Security'
  ),
);
const Addresses = lazy(() =>
  import(
    /* webpackPrefetch: true */ /* webpackChunkName: "lazyAddresses" */ '../../pages/Addresses'
  ),
);
const OrderHistory = lazy(() =>
  import(
    /* webpackPrefetch: true */ /* webpackChunkName: "lazyOrderHistory" */ '../../pages/OrderHistory'
  ),
);
const Favorites = lazy(() =>
  import(
    /* webpackPrefetch: true */ /* webpackChunkName: "lazyFavorites" */ '../../pages/Favorites'
  ),
);
// const ShoppingPlace = lazy(() =>
//   import(
//     /* webpackPrefetch: true */ /* webpackChunkName: "lazyShoppingPlace" */ '../../pages/ShoppingPlace'
//   ),
// );

export default function Routes() {
  return (
    <Suspense
      fallback={
        <div className="justify-content text-center fade-in">
          <Spinner
            className="spinner-loading"
            as="span"
            animation="border"
            role="status"
            aria-hidden="true"
          />
        </div>
      }
    >
      <Switch>
        {/* <Route exact path="/" component={Marketplace} /> */}
        <Route exact path="/" component={TempMarketplace} />
        <Route exact path="/undefined" component={TempMarketplace} />
        <Route exact path="/:merchantUrl" component={TempHome} />
        <Route
          exact
          path="/:merchantUrl/products/:productId"
          component={TempHome}
        />
        <Route
          exact
          path="/:merchantId/orders/:orderId/remake"
          component={TempHome}
        />
        <Route
          exact
          path="/auth/resetPassword/confirm"
          component={TempMarketplace}
        />
        <Route
          exact
          path="/user/main"
          component={() => <Layout page={MainData} selectedMenuItem={3} />}
          isPrivate
        />
        <Route
          exact
          path="/user/security"
          component={() => <Layout page={Security} selectedMenuItem={4} />}
          isPrivate
        />
        <Route
          exact
          path="/user/addresses"
          component={() => <Layout page={Addresses} selectedMenuItem={1} />}
          isPrivate
        />
        <Route
          exact
          path="/user/orderHistory"
          component={() => <Layout page={OrderHistory} selectedMenuItem={0} />}
          isPrivate
        />
        <Route
          exact
          path="/user/favorites"
          component={() => <Layout page={Favorites} selectedMenuItem={2} />}
          isPrivate
        />
        {/* <Route exact path="/shop/:urlCode" component={ShoppingPlace} /> */}
        <Redirect from="*" to="/" />
      </Switch>
    </Suspense>
  );
}
